module.exports = __webpack_public_path__ + "static/media/immutable_good.aacbcccc.png";